import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgHealthIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "#5E639B", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M14.2831 0.500843C13.1403 0.477964 12.0376 0.92186 11.2294 1.73015C10.4211 2.5384 9.97721 3.64107 10.0001 4.78388C10.0229 3.64107 9.57905 2.5384 8.77076 1.73015C7.96251 0.921896 6.85984 0.477986 5.71703 0.500843C5.71703 0.500843 0.000488281 0.500843 0.000488281 7.65054C0.000488281 7.65054 0.000488281 16.2166 10.0001 20.5C19.9996 16.217 19.9996 7.65054 19.9996 7.65054C19.9996 0.500843 14.2831 0.500843 14.2831 0.500843ZM14.9999 12.1668H11.6666V15.5001H8.33356V12.1668H5.00028V8.83378H8.33356V5.50049H11.6669V8.83378H15.0001L14.9999 12.1668Z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgHealthIcon);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/howAreYouSvg/HealthIcon.svg?url";
export default assetUrl;
